import Create from './Action';

export default Create;
